import { connect } from 'react-redux'
import AndroidLandscapeFullscreen from '../../components/LandscapeFullScreen/AndroidLandscapeFullscreen'

const mapStateToProps = state => ({
    isLandscape: state.getIn(['device', 'isLandscape']),
})

export default connect(mapStateToProps)(AndroidLandscapeFullscreen)
